import { createSlice } from '@reduxjs/toolkit';

import { initStateResponse } from '../basket/reducer';
import { type ISettingsState } from './types';

export const initialState: ISettingsState = {
  holidayPeriod: null,
};

const settingsSlice = createSlice({
  name: 'Settings',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(initStateResponse, (state, action) => {
      state.holidayPeriod = action.payload.holidayPeriod;
    });
  },
});

export default settingsSlice.reducer;
